import * as z from 'zod'

import {
  optionalText,
  ownershipFields,
  requiredAmount,
  requiredDate,
  requiredText,
  tagList,
  withOwnership,
} from '../utils/schema'

/**
 * Which way the money moved. The one question this flow cannot skip: a loan
 * filed without it used to always post as debt owed, silently, which is what
 * booked money the user had lent out as a liability. No default value — the
 * wizard forces the choice instead of guessing it.
 */
export enum LoanDirection {
  BORROWED = 'Borrowed',
  LENT = 'Lent',
}

export const loanSchema = withOwnership(z.object({
  ...ownershipFields(),
  direction: z.enum([LoanDirection.BORROWED, LoanDirection.LENT], {
    error: 'Choose whether this was borrowed or lent',
  }),
  assetName: requiredText('Name this loan'),
  /* Fixed by the flow, not collected — see ASSET_TYPE in ./index.ts. */
  assetType: z.literal('loan'),
  description: optionalText(),
  amount: requiredAmount('Enter the amount of the loan'),
  date: requiredDate('Enter the date the loan was made'),
  currency: optionalText(),
  tags: tagList(),
}))

export type LoanValues = z.infer<typeof loanSchema>
